$border: 1px solid;
$box-shadow-hover: inset 0px 0px 0px 2px;
$line-height: 24px;
$option-min-height: 42px;
$option-min-height-small: 40px;

:host {
  display: block;
  width: 100%;

  * {
    box-sizing: border-box;
  }
}

.#{$prefix}dropdown-option {
  position: relative;
  width: 100%;
  min-height: $option-min-height;
  margin: 2px 0;
  padding-top: 9px;
  padding-left: var(--textPaddingLeft, 12px);
  padding-bottom: 9px;
  padding-right: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  font-family: $font-family-base;
  line-height: $line-height;
  -webkit-appearance: none;
  box-shadow: inset 0 -1px 0 0 v(borderBottomColor);
  background-color: v(backgroundColor);
  outline: none;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.1s ease-out, color 0.1s ease-out;
  @include noneUserSelect();

  .#{$prefix}label {
    display: flex;
    align-items: center;
  }

  eon-ui-checkbox {
    align-self: flex-start;
  }

  eon-ui-icon {
    fill: v(borderActiveColor);
    margin-left: 8px;
    height: $line-height;
    opacity: 0;
  }

  &:hover {
    border: none;
    background-color: v(backgroundColorHover);
    color: v(textColor);

    eon-ui-checkbox {
      --labelColor: v(textColor);
      --borderColorSelected: var(--iconColorSelectedHover);
      --borderColor: var(--iconColorSelectedHover);
      --borderColorHover: var(--iconColorSelectedHover);
      --iconColorHover: var(--iconColorSelectedHover);
    }

    eon-ui-icon {
      fill: v(textColor);
      opacity: 0.5;
    }
  }

  &.#{$prefix}focus {
    border: none;
    background-color: v(backgroundColorHover);
    color: v(textColor);

    eon-ui-checkbox {
      --labelColor: v(textColor);
      --borderColorSelected: var(--iconColorSelectedFocus);
      --borderColor: var(--iconColorSelectedFocus);
      --borderColorHover: var(--iconColorSelectedFocus);
      --iconColorHover: var(--iconColorSelectedFocus);
    }

    eon-ui-icon {
      fill: v(textColor);
      opacity: 0.5;
    }
  }

  &.#{$prefix}selected {
    box-shadow: unset;

    eon-ui-icon {
      fill: v(backgroundColorHover);
      opacity: 1;
    }

    &.#{$prefix}focus eon-ui-icon,
    &:hover eon-ui-icon {
      fill: v(textColor);
    }
  }

  &.#{$prefix}small {
    min-height: $option-min-height-small;
    padding: 7px 12px 9px 12px;
    padding-left: var(--textPaddingLeft, 12px);
  }

  &.#{$prefix}multiselect {
    &:hover {
      text-decoration: none;
      background-color: v(backgroundColorHover) !important;
    }

    &.#{$prefix}focus {
      text-decoration: none;
      background-color: v(backgroundColorHover) !important;
    }

    &.#{$prefix}selected {
      background-color: inherit;
      box-shadow: inset 0 -1px 0 0 v(borderBottomColor);
    }
  }
}
